import { Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import React from "react";
import { QuotationStoryBlock } from "../../../components/QuotationStoryComponent/QuotationStoryComponent";
import { hyperlinksOptions, renderTextOptions } from "../../../utils/contentful/rich-text-formatting";

export const options: Options = {
  renderNode: {
    ...hyperlinksOptions.renderNode,
    [BLOCKS.QUOTE]: (node, children) => {
      if (Array.isArray(children) && children.length >= 2) {
        const author = children.slice(-1)[0];
        const content = <React.Fragment>{children.slice(0, -1)}</React.Fragment>;

        return (
          <QuotationStoryBlock className={"quotation-block"} author={author}>
            {content}
          </QuotationStoryBlock>
        );
      } else {
        return (
          <QuotationStoryBlock className={"quotation-block"} author={undefined}>
            {children}
          </QuotationStoryBlock>
        );
      }
    },
  },
  renderText: renderTextOptions,
};
